import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import { NotificationsPage } from './NotificationsPage';

/*
 * Replaces the stock notifications page. The plugin's page is an unnamed
 * `PageBlueprint.make` on plugin `notifications`, so it holds the id
 * `page:notifications`; an unnamed page in a `notifications` module takes that
 * id and stands in for it. The route ref is re-supplied from the plugin so the
 * sidebar item and the header bell keep resolving to `/notifications`.
 */
const honeNotificationsPage = PageBlueprint.make({
  params: {
    path: '/notifications',
    routeRef: notificationsPlugin.routes.root,
    title: 'Notifications',
    loader: async () => <NotificationsPage />,
  },
});

export const notificationsModule = createFrontendModule({
  pluginId: 'notifications',
  extensions: [honeNotificationsPage],
});
